const ITEMS = ["STRATEGY", "DIGITAL EXPERIENCE", "FULL-STACK DOMINANCE", "PERFORMANCE MARKETING", "BRAND ARCHITECTURE", "KINETIC DESIGN"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-white/10 bg-panel/60 overflow-hidden py-5 select-none" data-testid="editorial-marquee">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="font-display font-bold text-xl sm:text-2xl tracking-tight text-slate-500 flex items-center">
            <span className="px-6">{item}</span>
            <span className="text-volt text-sm">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
